// src/pages/DevHub/components/DevUrlPreview.tsx
// Replaces: .dev-url-preview, .method-tag, .url-text, and .dev-copy-btn inside url-preview

import React, { useState } from 'react';
import { Copy, Check } from 'lucide-react';
import { cn } from '../../../lib/utils';

interface DevUrlPreviewProps {
    method: string;
    url: string;
    className?: string;
}

const DevUrlPreview: React.FC<DevUrlPreviewProps> = ({ method, url, className }) => {
    const [copied, setCopied] = useState(false);

    const handleCopy = () => {
        navigator.clipboard.writeText(url);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    return (
        /*
         * .dev-url-preview:
         *   display: flex; align-items: stretch;
         *   background: #ffffff;
         *   border: 1px solid #dadce0;
         *   border-radius: 8px;
         *   margin-bottom: 24px;
         *   overflow: hidden;
         *   padding: 0;
         */
        <div className={cn(
            'flex items-stretch',
            'bg-white border border-[#dadce0] rounded-[8px]',
            'mb-[24px] overflow-hidden p-0',
            className,
        )}>
            {/*
             * .dev-url-preview .method-tag:
             *   background: #e8f0fe;   (--dev-primary-light)
             *   color: #174ea6;         (--dev-primary-color)
             *   padding: 12px 16px;
             *   font-weight: 700; font-size: 12px;
             *   border-right: 1px solid #dadce0;
             *   display: flex; align-items: center; justify-content: center;
             *   min-width: 80px;
             */}
            <div className="bg-[#e8f0fe] text-[#174ea6] px-[16px] py-[12px] font-bold text-[12px] border-r border-[#dadce0] flex items-center justify-center min-w-[80px]">
                {method}
            </div>

            {/*
             * .dev-url-preview .url-text:
             *   flex: 1; padding: 12px 16px;
             *   font-family: 'Roboto Mono', monospace;
             *   font-size: 13px; color: #54585d;
             *   white-space: pre-wrap; word-break: break-all;
             *   display: flex; align-items: center;
             */}
            <div className="flex-1 px-[16px] py-[12px] font-['Roboto_Mono',monospace] text-[13px] text-[#54585d] whitespace-pre-wrap break-all flex items-center">
                {url}
            </div>

            {/*
             * .dev-url-preview .dev-copy-btn:
             *   margin: 0 8px;
             *   align-self: center;
             *
             * + base .dev-copy-btn styles:
             *   padding: 8px; background: transparent; border: none; border-radius: 8px;
             *   color: #61666b; cursor: pointer;
             *   transition: all 0.2s cubic-bezier(0.4,0,0.2,1);
             *   display: flex; align-items: center; justify-content: center;
             *   :focus → outline: none
             *   :hover:not(:disabled) → background: #f1f3f4; color: #174ea6
             *   .success → color: #0d652d !important
             */}
            <button
                className={cn(
                    'mx-[8px] self-center',
                    'p-[8px] bg-transparent border-0 rounded-[8px]',
                    'cursor-pointer transition-all duration-200 [transition-timing-function:cubic-bezier(0.4,0,0.2,1)]',
                    'flex items-center justify-center leading-normal focus:outline-none',
                    copied
                        ? '!text-[#0d652d]'
                        : 'text-[#61666b] hover:bg-[#f1f3f4] hover:text-[#174ea6]',
                )}
                onClick={handleCopy}
                title={copied ? 'Copied!' : 'Copy URL'}
                aria-label={copied ? 'Copied!' : 'Copy URL to clipboard'}
            >
                {copied ? <Check size={14} /> : <Copy size={14} />}
            </button>
        </div>
    );
};

export default DevUrlPreview;
